// @flow

import { observer } from "mobx-react";
import React from "react";

import "./AnimatedIconCheck.scss";

@observer
export default class AnimatedIconCheck extends React.Component<*> {
    render() {
        return <i className="AnimatedIconCheck fa fa-check" />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/AnimatedIconCheck/AnimatedIconCheck.js